export default __webpack_public_path__ + "531e0bee54b2b5d5dff99ea02c8830b8.png";